import * as Sentry from '@sentry/react';
import App from './App';
import { Page } from './common/Grid';
import { Provider } from 'react-redux';
import { store } from 'store/store';
import { PermissionsProvider } from './context/PermissionsContext';

const SentryFallback = () => (
  <div className="flex flex-col items-center justify-center h-screen gap-4">
    <h1 className="text-2xl font-semibold">Something went wrong</h1>
    <p className="text-gray-600">An unexpected error occurred.</p>
    <button
      className="px-4 py-2 bg-primary-button text-white rounded-md"
      onClick={() => window.location.reload()}
    >
      Refresh page
    </button>
  </div>
);

export const CafeAdminModule = () => {
  return (
    <Sentry.ErrorBoundary fallback={<SentryFallback />}>
      <Provider store={store}>
        <PermissionsProvider>
          <Page classNames={['OperationsModule']}>
            <App />
          </Page>
        </PermissionsProvider>
      </Provider>
    </Sentry.ErrorBoundary>
  );
};
